import React from "react";
import { RightArrowSVG } from "../../../../common/components/icons/SVGIcon";
import { getArteryLabel } from "../../../../common/constants/Artery";
import { getMedical } from "../../../../common/constants/Operations";
import DetailItem from "./DetailItem";
import "./style.scss";

const ArteryDetailNewForAI = ({ toolsOpt, parent, handleOperation, handleMedicals, isDraggable, details }) => {
  const medicals = toolsOpt?.valueTools || [];
  const getIcon = (opt) => {
    const operation = getMedical(opt);
    if (operation) {
      return operation.icon;
    }
    return "";
  };

  const getValue = (opt) => {
    const operation = getMedical(opt);
    if (operation) {
      return operation.label;
    }
    return "";
  };

  const handleClick = (opt, index) => {
    if (handleOperation) {
      handleOperation(opt, index);
    }
  };

  const moveMedical = (from, to, medical) => {
    const newMedicals = [...medicals];
    const newDetails = [...details];
    // xóa vị trí của nó khi di chuyển ra khỏi key
    if (from !== -1) {
      newMedicals.splice(from, 1);
      newDetails.splice(from, 1);
    }
    // import vô lại vị trí mới
    newMedicals.splice(to, 0, medical);
    newDetails.splice(to, 0, details?.[from] || []);
    if (handleMedicals) {
      // cập nhật lại số lượng các details dựa trên số lượng
      const mixNewDetail = newMedicals.map((r, index) => {
        if (newDetails?.[index]) {
          return newDetails?.[index];
        } else {
          return undefined;
        }
      });
      handleMedicals(newMedicals, from, to, mixNewDetail);
    }
  };

  const stenosis = medicals
    .map((mc) => {
      const operation = getMedical(mc);
      return operation;
    })
    .filter((sten) => sten && sten.state && sten.state === "stenosis");

  const stents = medicals
    .map((mc) => {
      const operation = getMedical(mc);
      return operation;
    })
    .filter((sten) => sten && sten.state && sten.state === "in-stent");

  if ((!medicals || medicals.length === 0) && toolsOpt?.keyTools) {
    return (
      <div className="arteryDetail-empty">
        <strong style={{ marginLeft: "15px" }}>No suggested intervention for this artery</strong>
      </div>
    );
  } else if ((!medicals || medicals.length === 0) && !toolsOpt?.keyTools) {
    return null;
  }

  return (
    <div className="arteryDetail" style={{ position: "relative", backgroundColor: "transparent" }}>
      {!parent &&
        medicals.map((opt, index) => (
          <React.Fragment key={`${toolsOpt?.keyTools}-${opt}-${index}`}>
            {index !== 0 && (
              <div className="arteryDetail-arrow">
                <RightArrowSVG />
              </div>
            )}
            <DetailItem
              propStyle={{ minWidth: 150 }}
              isDraggable={isDraggable}
              label={getValue(opt)}
              icon={getIcon(opt)}
              pos={index}
              item={opt}
              moveItem={moveMedical}
              handleClick={() => handleClick(opt, index)}
            />
          </React.Fragment>
        ))}
    </div>
  );
};

export default ArteryDetailNewForAI;
